import api, { formatApiError, formatDate } from "@/lib/api";
import { toast } from "sonner";
import { Pencil } from "lucide-react";

const ISO = /^\d{4}-\d{2}-\d{2}$/;

/** Hoja de Pedidos: fecha anterior tachada + historial de reprogramaciones; solo admin edita. */
export const FechaHist = ({ o, admin, onSaved }) => {
  const h = o.fecha_entrega_hist || [];
  const ult = h[h.length - 1];
  const editar = async () => {
    const f = (window.prompt("Nueva fecha de entrega (AAAA-MM-DD)", (o.fecha_entrega || "").slice(0, 10)) || "").trim();
    if (!f) return;
    if (!ISO.test(f)) { toast.error("Formato de fecha: AAAA-MM-DD"); return; }
    try { await api.patch(`/orders/${o.id}/fecha-entrega`, { fecha: f, fecha_hasta: f }); toast.success("Fecha reprogramada"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="mt-0.5 space-y-0.5" data-testid={`fecha-hist-${o.numero}`}>
      {ult?.anterior && (
        <div className="text-[10px] leading-tight" title={h.map((x) => `${formatDate(x.anterior)} → ${formatDate(x.nueva)} · ${x.by} · ${new Date(x.at).toLocaleString("es-GT", { timeZone: "America/Guatemala" })}${x.origen === "repartidor" ? " (repartidor)" : ""}`).join("\n")}>
          <span className="line-through text-red-700">{formatDate(ult.anterior)}</span>
          <span className="text-zinc-600"> · {ult.by}{h.length > 1 ? ` · ${h.length} cambios` : ""}</span>
        </div>
      )}
      {admin && (
        <button type="button" onClick={editar} className="inline-flex items-center gap-0.5 text-[10px] text-[#002FA7] hover:underline" data-testid={`fecha-editar-${o.numero}`}>
          <Pencil className="w-3 h-3" /> Reprogramar
        </button>
      )}
    </div>
  );
};

/** Solo admin: cambia la dirección de entrega de ESTE pedido (la del cliente no se toca). */
export const DireccionEdit = ({ o, onSaved }) => {
  const editar = async () => {
    const d = (window.prompt("Dirección de entrega de este pedido (no cambia la del cliente)", o.direccion || "") || "").trim();
    if (!d || d === o.direccion) return;
    try { await api.patch(`/orders/${o.id}/direccion`, { direccion: d }); toast.success("Dirección actualizada"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <button type="button" onClick={editar} className="inline-flex items-center gap-0.5 text-[10px] text-[#002FA7] hover:underline" data-testid={`direccion-editar-${o.numero}`}>
      <Pencil className="w-3 h-3" /> Dirección
    </button>
  );
};
